import { INDEXARTICLES } from './eapiArticles';
import loadable from '../utils/loadable';

const APITerms = loadable(() => import('../components/EAPITermsComponent/components/articles/APITerms'));
const OtherTerms = loadable(() => import('../components/EAPITermsComponent/components/articles/OtherTerms'));
const IndexesList = loadable(() => import('../components/EAPITermsComponent/components/IndexesList'));
const AboutUs = loadable(() => import('../components/EAPITermsComponent/components/articles/AboutUs'));
const Definitions = loadable(() => import('../components/EAPITermsComponent/components/articles/Definitons'));
const OrderingServices = loadable(() => import('../components/EAPITermsComponent/components/articles/OrderingServices'));
const ContactTerms = loadable(() => import('../components/EAPITermsComponent/components/articles/ContactTerms'));
const Fees = loadable(() => import('../components/EAPITermsComponent/components/articles/Fees'));
const Apps = loadable(() => import('../components/EAPITermsComponent/components/articles/Apps'));
const Training = loadable(() => import('../components/EAPITermsComponent/components/articles/Training'));
const Security = loadable(() => import('../components/EAPITermsComponent/components/articles/Security'));
const Maintenance = loadable(() => import('../components/EAPITermsComponent/components/articles/Maintenance'));
const Licences = loadable(() => import('../components/EAPITermsComponent/components/articles/Licences'));
const TermsOfUse = loadable(() => import('../components/EAPITermsComponent/components/articles/TermsOfUse'));
const CustomerComputerSystems = loadable(() => import('../components/EAPITermsComponent/components/articles/CustomerComputerSystems'));
const Support = loadable(() => import('../components/EAPITermsComponent/components/articles/Support'));
const IntellectualProperty = loadable(() => import('../components/EAPITermsComponent/components/articles/IntellectualProperty'));
const CustomerData = loadable(() => import('../components/EAPITermsComponent/components/articles/CustomerData'));
const Confidentiality = loadable(() => import('../components/EAPITermsComponent/components/articles/Confidentiality'));
const Liability = loadable(() => import('../components/EAPITermsComponent/components/articles/Liability'));
const Indemnity = loadable(() => import('../components/EAPITermsComponent/components/articles/Indemnity'));
const ForceMajeure = loadable(() => import('../components/EAPITermsComponent/components/articles/ForceMajeure'));
const Termination = loadable(() => import('../components/EAPITermsComponent/components/articles/Termination'));
const Notices = loadable(() => import('../components/EAPITermsComponent/components/articles/Notices'));
const PartiesRelationship = loadable(() => import('../components/EAPITermsComponent/components/articles/PartiesRelationship'));
const Assignment = loadable(() => import('../components/EAPITermsComponent/components/articles/Assignment'));
const Severance = loadable(() => import('../components/EAPITermsComponent/components/articles/Severance'));
const EntireAgreement = loadable(() => import('../components/EAPITermsComponent/components/articles/EntireAgreement'));
const Variation = loadable(() => import('../components/EAPITermsComponent/components/articles/Variation'));
const NoWaiver = loadable(() => import('../components/EAPITermsComponent/components/articles/NoWaiver'));
const NonExclusivity = loadable(() => import('../components/EAPITermsComponent/components/articles/NonExclusivity'));
const LawJurisdiction = loadable(() => import('../components/EAPITermsComponent/components/articles/LawJurisdiction'));
const Schedule1 = loadable(() => import('../components/EAPITermsComponent/components/articles/Schedule1'));

export const ARTICLES = {
  apiterms: {
    title: 'API terms and conditions',
    component: APITerms,
  },
  otherterms: {
    title: 'Other applicable terms',
    component: OtherTerms,
  },
  indexes: {
    title: 'Index',
    component: () => (
      <IndexesList articles={INDEXARTICLES} />
    ),
  },
  'about-us': {
    title: 'Information about Us',
    component: AboutUs,
  },
  definitions: {
    title: 'Definitions and Interpretation',
    component: Definitions,
  },
  'ordering-services': {
    title: 'Ordering Services',
    component: OrderingServices,
  },
  'contact-terms': {
    title: 'The Services and the Term of the Contract',
    component: ContactTerms,
  },
  fees: {
    title: 'Fees and Payment',
    component: Fees,
  },
  apps: {
    title: 'The Applications',
    component: Apps,
  },
  training: {
    title: 'Training',
    component: Training,
  },
  security: {
    title: 'Security',
    component: Security,
  },
  maintenance: {
    title: 'Maintenance',
    component: Maintenance,
  },
  licences: {
    title: 'Licences',
    component: Licences,
  },
  'terms-of-use': {
    title: 'Applications and API Infrastructure Terms of Use',
    component: TermsOfUse,
  },
  'customer-computer-systems': {
    title: 'Customer Computer Systems',
    component: CustomerComputerSystems,
  },
  support: {
    title: 'Support',
    component: Support,
  },
  'intellectual-property': {
    title: 'Intellectual Property',
    component: IntellectualProperty,
  },
  'customer-data': {
    title: 'Customer Data',
    component: CustomerData,
  },
  confidentiality: {
    title: 'Confidentiality',
    component: Confidentiality,
  },
  liability: {
    title: 'Liability',
    component: Liability,
  },
  indemnity: {
    title: 'Indemnity',
    component: Indemnity,
  },
  'force-majeure': {
    title: 'Force Majeure',
    component: ForceMajeure,
  },
  termination: {
    title: 'Termination',
    component: Termination,
  },
  notices: {
    title: 'Notices',
    component: Notices,
  },
  'parties-relationship': {
    title: 'Relationship of Parties',
    component: PartiesRelationship,
  },
  assignment: {
    title: 'Assignment',
    component: Assignment,
  },
  severance: {
    title: 'Severance',
    component: Severance,
  },
  'entire-agreement': {
    title: 'Entire Agreement',
    component: EntireAgreement,
  },
  variation: {
    title: 'Variation',
    component: Variation,
  },
  'no-waiver': {
    title: 'No Waiver',
    component: NoWaiver,
  },
  'non-exclusivity': {
    title: 'Non-Exclusivity',
    component: NonExclusivity,
  },
  'law-jurisdiction': {
    title: 'Law and Jurisdiction',
    component: LawJurisdiction,
  },
  'schedule-1': {
    title: 'SCHEDULE 1',
    component: Schedule1,
  },
};

export default ARTICLES;
